import { render, staticRenderFns } from "./assignedProjects.vue?vue&type=template&id=0dd1a74c&"
import script from "./assignedProjects.vue?vue&type=script&lang=js&"
export * from "./assignedProjects.vue?vue&type=script&lang=js&"
import style0 from "./assignedProjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports